import { useHistory, useLocation } from "react-router-dom";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  isValidElement,
  isValidString,
} from "../../util/ApiHelper";
import { fetchStart, fetchSuccess } from "../../appRedux/actions";
import { axiosInstance, BASE_API_CONFIG } from "../../util/Api";
import { formatDate, } from "../../util/helper";
import { Card, Image, List } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";

const OfferProductView = () => {
  const history = useHistory();
  const { isMobile } = useGetBreakpoints();
  const dispatch = useDispatch();
  const location = useLocation();
  const isFromUserProfile = location.state?.isFromUserProfile;
  const { id } = useParams();
  const authUser = useSelector(({ auth }) => auth.userData);

  const [productData, setProductData] = useState(null);
  const [fileName, setFileName] = useState("");
  const getProductById = async (id) => {
    if (isValidString(id)) {
      dispatch(fetchStart());
      try {
        const productById = await axiosInstance.get(
          `${BASE_API_CONFIG.baseURL}/offer-products/${id}`
        );
        setProductData(productById?.data);
      } catch (error) {
        console.error("Error fetching product:", error);
      } finally {
        dispatch(fetchSuccess());
      }
    }
  };
  useEffect(() => {
    getProductById(id);
  }, [id]);

  useEffect(() => {
    const images = productData?.data?.primaryImage;
    if (Array.isArray(images)) {
      setFileName(images);
    } else if (typeof images === "string" && images) {
      setFileName([{ src: images }]);
    }
  }, [productData]);

  const data = [
    {
      label: "Posted Date",
      value: formatDate(productData?.data?.createdAt),
    },
    {
      label: "Product Name",
      value: productData?.data?.name,
    },
    {
      label: "Quantity Available",
      value: `${productData?.data?.qty} ${productData?.data?.uom}`,
    },
    {
      label: "Offer Price",
      value:  `INR ${productData?.data?.price} / ${productData?.data?.uom}`,
    },
    {
      label: "Company Name",
      value: productData?.data?.user.companyName,
    },
    {
      label: "Payment Terms",
      value: productData?.data?.paymentTerms,
    },
    {
      label: "Comments",
      value: productData?.data?.comments,
    },
  ];

  return (
    isValidElement(productData) && (
      <Card className="myexim-detail-card">
        <div className="myexim-table-title">
          <div>
            <LeftOutlined
              style={{ fontSize: "20px", color: '#434E5B'}}
              size="large"
              onClick={() => {
                history.goBack();
              }}
            />
          </div>
          Offer Product Details
        </div>
        <div
          className={`logo-with-list gx-mt-4 ${
            isMobile ? "gx-flex-column" : ""
          }`}
        >
          <div style={{ paddingRight: 16 }}>
            {isValidString(productData?.primaryImage) && (
              <div className={"logo-container"}>
                <div className={"logo-image"}>
                  <img
                    alt="..."
                    src={productData?.primaryImage}
                    width={isMobile ? "100%" : 120}
                    height={isMobile ? "100%" : 120}
                  />
                </div>
              </div>
            )}
          </div>
          <div style={{ flex: 1 }}>
            <List
              itemLayout="horizontal"
              dataSource={data}
              renderItem={(item) =>
                item?.value && (
                  <List.Item className="myexim-details-list">
                    <List.Item.Meta
                      title={<div>{item.label}</div>}
                      description={isValidString(item.value) ? item.value : "-"}
                    />
                  </List.Item>
                )
              }
            />
            {fileName?.length > 0 && (
              <div className="attachments gx-mt-3">
                <div className="sub-header ">Attachments</div>
                <div className="gx-mt-4">
                  Please find the below attachment as a reference
                </div>
                <div className="gx-pt-4">
                  {fileName?.map((fileName, index) => (
                    <div key={index} className="gx-pb-3">
                      <Image
                        className="gx-rounded-lg"
                        width={isMobile ? "100%" : 150}
                        height={isMobile ? "100%" : 150}
                        src={fileName?.src}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </Card>
    )
  );
};

export default OfferProductView
